<template>
  <div>
    <table v-if="!node">
      <tbody>
        <tr v-for="node2 in nodes" @click="node = node2">
          <td>{{ node2.label }}</td>
        </tr>
      </tbody>
    </table>
    
    <table v-if="node">
      <tbody>
        <tr v-for="option in node.options">
          <td>{{ option.label }}</td>
        </tr>
      </tbody>
    </table>
    
    
    {{ node }}
  </div>
</template>

<script>
  export default {
    name: 'trigger_device',
    props: ['type'],
    data () {
      return {
        selectedTrigger: null,
        triggerValue: null,
        sendTriggerTimer: null,
        node: null,
        capability: null
      }
    },
    created() {
      // Skickar upp triggern var 100ms till vår parent som tar hand om den
      // så vi kan skapa vårt objekt vid ett senare tillfälle.
      this.sendTriggerTimer = setInterval(() => {
        this.$emit('options', {
          trigger: this.formattedTrigger,
          type: 'number'
        })
      }, 100)
    },

    destroyed () {
      clearInterval(this.sendTriggerTimer)
    },

    methods: {
      triggerCapabilities (capabilities) {
        let bajs = []

        capabilities.forEach(capability => {
          if (capability in this.capabilities) {
            this.capabilities[capability].triggers.forEach(trigger => {
              bajs.push(trigger)
            })
          }
        })

        return bajs
      }
    },
    computed: {
      formattedTrigger () {
        if (!this.selectedTrigger)
          return {}

        const obj = {
          systemType: 'device',
          subtype: 'state',
          operator: 'eq',
          sourceNode: this.selectedTrigger.nodeId
        }

        return obj
      },

      nodes () {
        return this.$root.data.nodes.filter(node => {
          let con = true
          if (!('name' in node) || node.name.length < 1)
            con = false
          return con
        }).map(node => {
          return {
            label: node.name,
            nodeId: node.id,
            options: this.triggerCapabilities(node.capabilities).map(cap => {
              return {
                label: cap.name,
                type: cap.type
              }
            })
          }
        })
      },

      triggerType () {
        if (this.selectedTrigger)
          return this.selectedTrigger.type
        return ''
      },

      capabilities () {
        return {
          switchBinary: {
            name: {
              sv: 'Mottagare på/av'
            },
            type: 'boolean',
            set: true,
            get: true,
            triggers: [
              { name: 'tänds', value: true },
              { name: 'släcks', value: false }
            ]
          },
          switchLevel: {
            name: {
              sv: 'Mottagare – dimmer'
            },
            type: 'number',
            set: true,
            get: true,
            triggers: [
              { name: 'dimras', type: 'number' }
            ]
          },
          temperature: {
            name: {
              sv: 'Temperatur'
            },
            type: 'number',
            set: false,
            get: true,
            triggers: [
              { name: 'temperaturen ändras', type: 'number' }
            ]
          },
          notificationMotion: {
            name: {
              sv: 'Rörelsevakt'
            },
            type: 'boolean',
            set: false,
            get: true,
            triggers: [
              { name: 'rörelse detekteras', value: true },
              { name: 'ingen rörelse detekteras', value: false}
            ]
          }
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/automationer/trigger_device.vue